/**
 * Maps a content `type` (as returned by the search/catalog APIs) to the
 * registered Vue component name used to render that content as a card.
 *
 * Consumed by `theCards.vue` and `theProductCards.vue` to dynamically choose
 * the card component for each search result.
 */
export const cardTypeMap = {
  podcast: "pod-cast-card",
  video: "videos-card",
  track: "videos-card",
  "video-track": "videos-card",
  course: "cert-card",
  path: "learning-path-result",
  webinar: "event-result",
  event: "event-result",
  "instructor-led": "instructor-led-result",
  tutorial: "tutorials-result",
  "practice-exam": "practice-exam-result",
  challenge: "challenge-result",
  "exam-voucher": "exam-voucher-card",
  bundle: "bundle-card",
  lab: "labs-card",
  scorm: "scorm-card",
  "graded-labs": "graded-lab-card",
} as const;

export type CardType = keyof typeof cardTypeMap;

export default cardTypeMap;
